import { Component, Input } from '@angular/core';

@Component({
    selector: 'ins-knowledge-base-carousel',
    templateUrl: 'knowledge-base-carousel.component.html',
    styleUrls: ['./knowledge-base-carousel.component.scss']
})
export class KnowledgeBaseCarouselComponent {
    @Input() knowledgeBaseItems = [];
    @Input() onDark: boolean = false;
}
